import { Languages } from '@chiroup/core/enums/Languages.enum';
import { prescription } from '@chiroup/core/functions/createPrescription';
import React from 'react';
import { EditorView } from '../form/EditorView';

type Props = {
  index: number;
  exercise: any;
  language: Languages;
  primaryColor?: string;
  small?: boolean;
};

const ReportPrintExercise: React.FC<Props> = ({
  index,
  exercise,
  language,
  primaryColor = '#000000',
  small,
}) => {
  return (
    <div className={['relative w-full inline-block', small ? 'text-xs' : ''].join(' ')}>
      {exercise.img && (
        <div style={{ width: 100, height: 100 }} className="mr-4 object-contain float-left">
          <img
            src={
              exercise.img
                ? `${
                    exercise.img.startsWith('http')
                      ? exercise.img
                      : `${import.meta.env.VITE_S3_ASSETS_URL}/${exercise.img}`
                  }?w=100&q=80`
                : ''
            }
            alt={exercise?.name}
            width="100px"
            height="auto"
            style={{ maxHeight: '100%', maxWidth: '100%' }}
          />
        </div>
      )}
      <div
        className={['font-extrabold', small ? 'text-xs' : 'text-lg'].join(' ')}
        style={{
          color: primaryColor,
        }}
      >
        {language === Languages.es && exercise?.spanishName
          ? exercise?.spanishName
          : exercise?.name}
      </div>
      <div className="font-semibold">{prescription(exercise, language)}</div>
      {!!exercise.prescriptionNotes && <div className="italic">{exercise.prescriptionNotes}</div>}
      <div className="block overflow-hidden pb-4">
        <EditorView
          value={
            (language === Languages.es && exercise?.spanishDescr
              ? exercise?.spanishDescr
              : exercise?.descr) || ''
          }
        />
      </div>
    </div>
  );
};

export default ReportPrintExercise;
